<div class="flex flex-col items-center bg-[#F4F5F7] h-full overflow-y-auto">
  <div class="md:max-w-[40vw] w-full">
    <div class="flex items-center mt-5 cursor-pointer" [routerLink]="['/create-account']"
      routerLinkActive="router-link-active">
      <mat-icon class="text-[#7A869A] rtl:rotate-180 cursor-pointer me-1">keyboard_arrow_left</mat-icon>
      Back
    </div>

    <h1>Terms and Conditions</h1>

    <div>
      <h3>1. Introduction:</h3>
      <p>
        By creating an account and placing orders on our website, you agree to
        comply with and be bound by the following terms and conditions. Please
        review them carefully before using our services.
      </p>
    </div>

    <div>
      <h3>2. Account Creation Eligibility:</h3>
      <p>
        You must be at least 18 years old to create an account. Account
        Information: You agree to provide accurate and complete information
        during the registration process and to update such information to keep
        it accurate and complete. Account Security: You are responsible for
        maintaining the confidentiality of your account password and for all
        activities that occur under your account.
      </p>
    </div>

    <div>
      <h3>3. Online Ordering Order Acceptance:</h3>
      <p>
        All orders placed through our website are subject to acceptance by us.
        We reserve the right to refuse or cancel any order for any reason. Menu
        and Pricing: All menu items and prices are subject to change without
        notice. While we strive to provide accurate information, errors may
        occur. In the event of a pricing error, we reserve the right to cancel
        any orders placed at the incorrect price. Payment: Payment must be made
        at the time of order placement. We accept online payment and cash on
        delivery (COD).
      </p>
    </div>

    <div>
      <h3>4. Cancellations and Modifications Order Modifications:</h3>
      <p>
        After order confirmation, modifications may not be possible. Order
        Cancellations: After order confirmation, cancellations may not be
        possible, and you may be charged for the order.
      </p>
    </div>

    <div>
      <h3>5. Returns and Refunds No Refund Policy:</h3>
      <p>
        Due to the perishable nature of our products, we do not offer refunds
        under any circumstances. If there is an issue with your order, please
        contact us immediately, and we will do our best to assist you.
      </p>
    </div>

    <div>
      <h3>6. Shipping Policy</h3>
      <p>
        Delivery Areas: We deliver within specified areas only. Availability may
        vary based on your location.
        <br />
        Delivery Fees: Delivery charges may apply depending on your location and
        order total. These fees will be displayed at checkout before confirming
        your order.
        <br />
        Estimated Delivery Time: We strive to deliver orders within 90 minutes; however, delivery times may vary due to external factors such as
        traffic, weather conditions, or high order volume. While we make every effort to meet the estimated timeframe,
        delays may occur beyond our control.
        <br />
        Missed Deliveries: If you are unavailable at the time of delivery, our
        delivery personnel will attempt to contact you. If the order cannot be
        delivered, it may be returned, and no refunds will be provided.
      </p>
    </div>

    <div>
      <h3>7. Privacy Policy</h3>
      <p>
        Your privacy is important to us. Please review our [Privacy Policy] to
        understand how we collect, use, and protect your personal information.
      </p>
    </div>

    <div>
      <h3>8. Changes to Terms and Conditions</h3>
      <p>
        We reserve the right to update or modify these terms and conditions at
        any time without prior notice. Your continued use of our website
        following any changes constitutes your acceptance of the new terms and
        conditions.
      </p>
    </div>

    <div>
      <h3>9. Contact Information</h3>
      <p>
        For any questions regarding these Terms and Conditions, please contact
        us at: [Insert Contact Information Here]
      </p>
    </div>

    <hr>
    <hr>
    <h2 class="mt-2">Privacy Policy</h2>

    1. Introduction At [Company Name], we are committed to protecting your
    privacy. This Privacy Policy explains how we collect, use, disclose, and
    safeguard your information when you visit our website and use our online
    ordering services. Please read this policy carefully.
    <br />
    <br>
    2. Information We Collect Personal Information: We may collect personal
    information such as your name, email address, phone number, delivery
    address, and payment information when you create an account or place an
    order. Non-Personal Information: We may collect non-personal information
    such as your browser type, operating system, and IP address to help us
    improve our website and services.
    <br />
    <br>
    3. How We Use Your Information We use the information we collect in the
    following ways: To Process Orders: To process and fulfill your orders,
    including sending you emails to confirm your order status and delivery. To
    Improve Our Services: To understand how our customers use our website and
    services, and to make improvements. To Communicate with You: To send you
    updates, promotional materials, and other information that may be of
    interest to you. You can opt-out of receiving these communications at any
    time.
    <br />
    <br>
    4. How We Share Your Information We do not sell, trade, or otherwise
    transfer your personal information to outside parties except as described
    below: Service Providers: We may share your information with third-party
    service providers who assist us in operating our website, conducting our
    business, or servicing you, so long as those parties agree to keep this
    information confidential. Legal Requirements: We may disclose your
    information if required to do so by law or in response to valid requests by
    public authorities.
    <br />
    <br>
    5. Data Security We implement a variety of security measures to maintain the
    safety of your personal information. However, no method of transmission over
    the internet or method of electronic storage is 100% secure, and we cannot
    guarantee its absolute security.
    <br />
    <br>
    6. Your Rights You have the right to: Access: Request access to the personal
    information we hold about you. Correction: Request correction of any
    inaccurate or incomplete information. Deletion: Request deletion of your
    personal information, subject to certain exceptions.
    <br />
    <br>
    7. Cookies and Tracking Technologies We use cookies and similar tracking
    technologies to track the activity on our website and hold certain
    information. You can instruct your browser to refuse all cookies or to
    indicate when a cookie is being sent.
    <br />
    <br>
    8. Changes to This Privacy Policy We may update our Privacy Policy from time
    to time. We will notify you of any changes by posting the new Privacy Policy
    on this page. You are advised to review this Privacy Policy periodically for
    any changes.
    <br />
    <br>
    9. Contact Us If you have any questions about this Privacy Policy, please
    contact us at: [Insert Contact Information Here]
  </div>
</div>